import { ISkeletonData, ITrackEntry, Spine } from "pixi-spine";
import { IRandomInterval } from "./Context/RandomInterval";
import { ISystemContext } from "./Context/SystemContext";
import { IJackpotDisplay } from "./IJackpotDisplay";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { CreateElement, CreateSpineResources, Log, LogGroup, Safe, Scale, Size, shuffle } from "./MyHelpers";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { ScreenProtocol, ScreenProtocolScope } from "./ScreenProtocol";
import { JackpotDisplay, JackpotDisplayType, Settings } from "./Settings";
import { ZIndex } from "./ZIndex";
import * as PIXI from 'pixi.js';
import { JackpotText } from "./JackpotText";
import { JackPotTextParams } from "./JackPotTextParams";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage } from "./ResourceManager/ResourceManager";
import { JSONResource } from "./ResourceManager/JSONResource";
import { AtlasResource } from "./ResourceManager/AtlasResource";
import { IRandomTimeout } from "./Context/RandomTimeout";
import { RegisterPixi, UnregisterPixi } from "./PixiDebug";
import { IInterval } from "./Context/Interval";
import { FrontendErrorCode, JackpotLevel } from "./api";
import { service } from "./services";
import { FontResource } from "./ResourceManager/FontResource";
import { JackpotDisplayProperties } from "./JackpotDisplayProperties";
import { DecodedImageResource, ImageResource } from "./ResourceManager/ImageResource";
import { Orientation } from "./FitScreen";
import { JPContainerProps, JPFrameProps } from "./JackpotDisplayResponsive";
import { CanvasSprite } from "./slot/Sprite/CanvasSprite";
import { SpriteResource } from "./ResourceManager/SpriteResource";
import { frameProps, IJackpotDisplayResponsive, OnUpdateAppCallbackHandler } from "./IJackpotDisplayPIXIAPPResponsive";

export class JackpotDisplayJubileeLinkResponsivePIXIAPP extends IJackpotDisplayResponsive {

	//protected jp3textShared: JackpotText = null;
	//protected jp4textShared: JackpotText = null;
	public constructor(params: JackpotDisplayParams) {
		super(params);
		this.systemContext = params.systemContext.CreateSubContext("JackpotDisplayJubileeLinkResponsivePIXIAPP");
		this.resid = params.resid.Add("JackpotDisplayJubileeLinkResponsivePIXIAPP");
		this.screenProtocolScope = new ScreenProtocolScope("JackpotDisplayJubileeLinkResponsivePIXIAPP");
		this.screenProtocol = params.screenProtocol;

		this.jackpot = Settings.ResourcesFolder + `multigame/multigame/img/`;
		this.viewSize = params.viewSize;
		this.logGroup = new LogGroup("JackpotDisplayJubileeLinkResponsivePIXIAPP");

		// this would be "view" with jackpot frames
		this.view = CreateElement("div", {
			//classes: [this.resid.ID()],
			style: {
				position: "absolute",
				top: "0px",
				left: "0px",
				width: this.viewSize.Width + "px",
				height: this.viewSize.Height + "px",
				zIndex: "" + ZIndex.JackpotDisplay,
			}
		});
		this.view.className = this.resid.ID();

		this.restoreWebGlInterval = this.systemContext.TimingContext().CreateInterval("restoreWebGlInterval", 500, async () => {
			let success = this.tryRecoverWebglContext();

			// success, stop timer
			if (!success)
			{
				this.recoverFailCount++;
				if (this.recoverFailCount == this.maxRecoverFailCount)
				{
					await service.api.frontendError(FrontendErrorCode.WebGLRecoverFail, `${this.resid.ID()} in ${this.recoverFailCount} tries`);
				}
			}
		});
		
	}

	// protected skeletonJP4: ISkeletonData;
	// protected skeletonJP3: any;
	// protected skeletonJP2: any;
	// protected skeletonJP1: any;
	// protected titleJackpotSkeletonData: ISkeletonData;
	public override async PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager) {
		// this.resourceJP4 = await PIXI.Assets.load(this.jackpot + "/FramesSpine/JP4Spine/FrameJP4.json");
		// this.resourceJP3 = await PIXI.Assets.load(this.jackpot + "/FramesSpine/JP3Spine/FrameJP3.json");
		// this.resourceJP2 = await PIXI.Assets.load(this.jackpot + "/FramesSpine/JP2Spine/FrameJP2.json");
		// this.resourceJP1 = await PIXI.Assets.load(this.jackpot + "/FramesSpine/JP1Spine/FrameJP1.json");
		if(loadingStage != LoadingStage.System) return ;
			await this.PrepareResourcesGamePreload(resourceManager);					
	}


	//Add atlas , json , to resource manager 
	protected override async PrepareResourcesGamePreload(resourceManager: IWriteOnlyResourceManager): Promise<void> {
		await super.PrepareResourcesGamePreload(resourceManager);
		// resourceManager.Add(new FontResource(this.jackpot + "/fonts/newzone.ttf", this.resid.ScopedResourceName("JackpotFont")));		
		// for (let jackpotLevel = 1; jackpotLevel <= 4; jackpotLevel++) {
		// 	resourceManager.Add(new JSONResource(`${this.jackpot}/FramesSpine/JP${jackpotLevel}Spine/FrameJP${jackpotLevel}.json`, this.resid.ScopedResourceName(`JP${jackpotLevel}FrameSpineJson`)));
		// 	resourceManager.Add(new AtlasResource(`${this.jackpot}/FramesSpine/JP${jackpotLevel}Spine/FrameJP${jackpotLevel}.atlas`, this.resid.ScopedResourceName(`JP${jackpotLevel}FrameSpineAtlas`)));
		// }

		// //Load Title Spine
		// resourceManager.Add(new JSONResource(`${this.jackpot}/TitleSpine/JackpotTitle.json`, this.resid.ScopedResourceName(`JackpotTitleSpineJson`)));
		// resourceManager.Add(new AtlasResource(`${this.jackpot}/TitleSpine/JackpotTitle.atlas`, this.resid.ScopedResourceName(`JackpotTitleSpineAtlas`)));		
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotsResources-Slider/" + this.jackpotName + "/titleJackpotDisplay", this.resid.Add("title"), true, this.logGroup.Add("title"), true));
		resourceManager.Add(new DecodedImageResource(this.jackpot + `JackpotDisplay${this.jackpotName}/FrameJackpot_1Screen/diamond_frame_jackpots.png`, this.resid.ScopedResourceName(["jp4", "image"])));
		resourceManager.Add(new DecodedImageResource(this.jackpot + `JackpotDisplay${this.jackpotName}/FrameJackpot_1Screen/RubyJackpot_1Screen.png`, this.resid.ScopedResourceName(["jp3", "image"])));
		resourceManager.Add(new DecodedImageResource(this.jackpot + `JackpotDisplay${this.jackpotName}/FrameJackpot_1Screen/emmerald_frame_jackpots.png`, this.resid.ScopedResourceName(["jp2", "image"])));
		resourceManager.Add(new DecodedImageResource(this.jackpot + `JackpotDisplay${this.jackpotName}/FrameJackpot_1Screen/sapphire_frame_jackpots.png`, this.resid.ScopedResourceName(["jp1", "image"])));
		//resourceManager.Add(new ImageResource(this.jackpot + "JackpotDisplayPyramid/FrameJackpot_1Screen/DRAGON-JACKPOT-NAME.png", this.resid.ScopedResourceName(["DragonJackpotName"])));		
		resourceManager.Add(new FontResource(this.jackpot + "fonts/newzone.ttf", this.resid.ScopedResourceName("JackpotFont")));
		
	}


	public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void> {
		if (loadingStage != LoadingStage.System) return;
		this.jp4Img = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["jp4", "image"]));
		this.jp3Img = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["jp3", "image"]));
		this.jp2Img = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["jp2", "image"]));		
		this.jp1Img = resourceManager.Get<DecodedImageResource>(this.resid.ScopedResourceName(["jp1", "image"]));
		this.titleImg = resourceManager.Get<SpriteResource>(this.resid.ScopedResourceName(["title"]));
		await this.JPText();
		await this.ResourcesLoadedJackpotLevels(resourceManager)	
		// await this.CreatejackpotFrames();	
		// await this.Create();
		const originalTitleProps ={
			width: 560,
			height: 315 
		}

		const availableSpace = 1920 - frameProps[JackpotLevel.Jp2].containerWidth - frameProps[JackpotLevel.Jp1].containerWidth;
		const width = Math.min(availableSpace, 560);
		const scale = width / originalTitleProps.width;
		const titleProps = {
			width: originalTitleProps.width * scale,
			height: originalTitleProps.height * scale
		}
		
		// this.titleSpriteAnim = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("title")).sprite, canvasSize: new Size(Scale.W(titleProps.width), Scale.H(titleProps.height))});
	}
	


	//protected arrayMapFrameSpine: Spine[] = [];
	// protected titleJackpotSpine : Spine = null;
	protected async ResourcesLoadedTitleSpine(){

	}

	// protected async ResourcesLoadedJackpotLevels(resourceManager: IReadOnlyResourceManager)
	// {		
		
	// 	//ADD VALUE JP4 INTO SPINE
	// 	await this.jackpotTextMapping[JackpotLevel.Jp4]?.ResourcesLoaded(resourceManager);
	// 	this.jackpotTextMapping[JackpotLevel.Jp4]?.Start();		

	// 	//ADD VALUE JP3 INTO SPINE
	// 	await this.jackpotTextMapping[JackpotLevel.Jp3]?.ResourcesLoaded(resourceManager);
	// 	this.jackpotTextMapping[JackpotLevel.Jp3]?.Start();
		
	// 	//ADD VALUE JP2 INTO SPINE
	// 	await this.jackpotTextMapping[JackpotLevel.Jp2]?.ResourcesLoaded(resourceManager);
	// 	this.jackpotTextMapping[JackpotLevel.Jp2]?.Start();

	// 	//ADD VALUE JP1 INTO SPINE
	// 	await this.jackpotTextMapping[JackpotLevel.Jp1]?.ResourcesLoaded(resourceManager);
	// 	this.jackpotTextMapping[JackpotLevel.Jp1]?.Start();

	// 	this.jackpotTextMapping[JackpotLevel.Jp4]?.Draw();
	// 	this.jackpotTextMapping[JackpotLevel.Jp3]?.Draw();
	// 	this.jackpotTextMapping[JackpotLevel.Jp1]?.Draw();
	// 	this.jackpotTextMapping[JackpotLevel.Jp2]?.Draw();


	// }

	public override TitleHide() {
		//throw new Error("Method not implemented.");
		// if(this.titleJackpotSpine == null) return;
		
		// this.titleJackpotSpine.visible = false;
		// this.titleJackpotSpine?.skeleton?.setBonesToSetupPose();
        // this.titleJackpotSpine?.skeleton?.setToSetupPose();
        // this.titleJackpotSpine?.skeleton?.setSlotsToSetupPose();

		// if (this.titleJackpotSpine.state == null) return;
		// this.titleJackpotSpine?.state?.clearTracks();
        // this.titleJackpotSpine?.update(0);
	}
	public override TitleShow() {
		//throw new Error("Method not implemented.");
		// if (this.titleJackpotSpine)
		// {
		// 	return;
		// }
		// this.titleJackpotSpine.visible = true;
		// this.titleJackpotSpine.state?.setAnimation(0,"idle",true);
	}
	public override StartAnimations(): void {
		//throw new Error("Method not implemented.");
	}
	public override StopAnimations(): void {
		//throw new Error("Method not implemented.");
	}
	public override View(): HTMLElement {
		//throw new Error("Method not implemented.");
		return this.view;
	}

	public override Update(): void {
		this.canvasTextureJP4Value?.texture?.update();
		
		this.canvasTextureJP3Value?.texture?.update();
		
		this.canvasTextureJP2Value?.texture?.update();
		this.canvasTextureJP1Value?.texture?.update();
		this.jackpotTextMapping[JackpotLevel.Jp4]?.Draw();
		
		this.jackpotTextMapping[JackpotLevel.Jp3]?.Draw();
		
		this.jackpotTextMapping[JackpotLevel.Jp1]?.Draw();
		this.jackpotTextMapping[JackpotLevel.Jp2]?.Draw();

		this.OnUpdateAppCallback?.();

	}

	public override OnUpdateAppCallback: OnUpdateAppCallbackHandler = null;

	protected restoreWebGlInterval: IInterval = null;
	protected recoverCount: number = 0;
	protected recoverFailCount: number = 0;
	protected readonly maxRecoverFailCount = 5;

	protected webglcontextlostInstance: () => void = this.webglcontextlost.bind(this);
	protected lostCount: number = 0;

	protected async webglcontextlost() {
		this.lostCount++;
		Log.Error(this.logGroup, `Webgl context lost, count: ${this.lostCount}`);
		await service.api.frontendError(FrontendErrorCode.WebGLContextLost, `${this.resid.ID()}, count: ${this.lostCount}`);

		// try recover right now, or start timer to try recover later
		let success = this.tryRecoverWebglContext();
		if (success) {
			// all good
			success = null;
			return;
		}

		// error recovering, start timer
		this.restoreWebGlInterval.Start();
	}

	protected async tryRecoverWebglContext(): Promise<boolean> {
		if (!this.created) {
			this.restoreWebGlInterval.Stop();
			this.recoverFailCount = 0;

			// app not created, don't care
			return true;
		}

		console.log(this.resid.ID() + " trying to recover");
		await service.api.frontendError(FrontendErrorCode.WebGLContextRecovering, `${this.resid.ID()}`);
		try {
			await service.api.frontendError(FrontendErrorCode.WebGLDestroy, `${this.resid.ID()}`);
			this.InternalDestroy();
			await service.api.frontendError(FrontendErrorCode.WebGLDestroySuccess, `${this.resid.ID()}`);
		}
		catch (ex) {
			await service.api.frontendError(FrontendErrorCode.WebGLDestroyError, `${this.resid.ID()}: ${ex.toString()}`);
		}

		try {
			// Log.Debug(this.logGroup, `tryRecoverWebglContext() ${this.resid.ID()} recreating`);
			await service.api.frontendError(FrontendErrorCode.WebGLCreate, `${this.resid.ID()}`);
			// this.InternalCreate();

			// all fine, stop timer
			this.restoreWebGlInterval.Stop();
			console.log(this.resid.ID() + " recover success");

			this.recoverCount++;
			this.restoreWebGlInterval.Stop();
			this.recoverFailCount = 0;

			await service.api.frontendError(FrontendErrorCode.WebGLCreateSuccess, `${this.resid.ID()}`);
			await service.api.frontendError(FrontendErrorCode.WebGLContextRecovered, `${this.resid.ID()}, recover count: ${this.recoverCount}`);

			return true;
		}
		catch (ex) {
			await service.api.frontendError(FrontendErrorCode.WebGLCreateError, `${this.resid.ID()}, ${ex.toString()}`);

			console.log(this.resid.ID() + " error recovering", ex);

			// prevent spamming the backend
			if (this.recoverFailCount < this.maxRecoverFailCount) {


				if (ex.message.toLowerCase().includes("this browser does not support webgl")) {
					await service.api.frontendError(FrontendErrorCode.WebGLNotSupported, `${this.resid.ID()}, error: ${ex.toString()}`);
				}
				else {
					await service.api.frontendError(FrontendErrorCode.WebGLRecoverError, `${this.resid.ID()}, error: ${ex.toString()}`);
				}
			}
		}

		return false;
	};

	protected override async CreatejackpotFrames()
	{

		this.JP4Background = new PIXI.Sprite(PIXI.Texture.from(this.jp4Img.DecodedImage()));
		this.JP4Background.name = 'JP4-Image';
		this.JP3Background = new PIXI.Sprite(PIXI.Texture.from(this.jp3Img.DecodedImage()));
		this.JP3Background.name = 'JP3-Image';
		this.JP2Background = new PIXI.Sprite(PIXI.Texture.from(this.jp2Img.DecodedImage()));
		this.JP2Background.name = 'JP2-Image';
		this.JP1Background = new PIXI.Sprite(PIXI.Texture.from(this.jp1Img.DecodedImage()));
		this.JP1Background.name = 'JP1-Image';
		this.titleSpriteAnim = new PIXI.Sprite(PIXI.Texture.from(this.titleImg.sprite.GetDecodedFrame(0)));
		this.titleSpriteAnim.name = 'title-Image';

		let textureCanvasJP4 = PIXI.Texture.from(this.jackpotTextMapping[JackpotLevel.Jp4].CanvasView().Canvas());
		this.canvasTextureJP4Value = new PIXI.Sprite(textureCanvasJP4);
		this.canvasTextureJP4Value.name = 'JP4-text';
		// this.canvasTextureJP4Value.scale.set(1.5);

		let textureCanvasJP3 = PIXI.Texture.from(this.jackpotTextMapping[JackpotLevel.Jp3].CanvasView().Canvas());
		this.canvasTextureJP3Value = new PIXI.Sprite(textureCanvasJP3);
		this.canvasTextureJP3Value.name = 'JP3-text';
		// this.canvasTextureJP3Value.scale.set(1.5);

		let textureCanvasJP2 = PIXI.Texture.from(this.jackpotTextMapping[JackpotLevel.Jp2].CanvasView().Canvas());
		this.canvasTextureJP2Value = new PIXI.Sprite(textureCanvasJP2);
		this.canvasTextureJP2Value.name = 'JP2-text';
		// this.canvasTextureJP2Value.scale.set(1.5);


		let textureCanvasJP1 = PIXI.Texture.from(this.jackpotTextMapping[JackpotLevel.Jp1].CanvasView().Canvas());
		this.canvasTextureJP1Value = new PIXI.Sprite(textureCanvasJP1);
		this.canvasTextureJP1Value.name = 'JP1-text';
		// this.canvasTextureJP1Value.scale.set(1.5);

	}
	
	public override async Create(app?: PIXI.Container) {
		await super.Create(app);
		this.created = true;
	}

	/** use for destroy  App Pixi.js if that exist*/
	public override Destroy() {
		this.InternalDestroy();
		this.created = false;
		this.restoreWebGlInterval.Stop();
	}

	protected override async CreateLandscapeView(): Promise<void> {
		await super.CreateLandscapeView();
		this.jpTitleContainer.position.y = Scale.X(-200);
		
	}
}

